/*
 Created by CHT 2019/9/17 17:49
 日期选择
 */
import BaseItem from "../BaseItem"
import {
  DATA_TYPE__LONG,
  DATE_TYPE__DAY,
  DATE_TYPE__SECTION, DEFAULT_VALUE__CUSTOM, DEFAULT_VALUE__FORMULA, DEFAULT_VALUE__RELATE_DATA,
  FORM_ITEM__DATE,
  FORM_STATUS__FILL,
  DEFAULT_VALUE__CREATE_TIME, FORM_ITEM__TABLE
} from "../types"
import {defaultValueInit, formatDate} from "../utils"

class DateInput extends BaseItem {

  constructor() {
    super()
    this.value = null
    this.dateType = this.dataTypeList[0].value
    this.formatStr = 'yyyy-MM-dd HH:mm'
    this.defaultValue = {
      defaultType: ''
    }
  }

  get title() {
    return this.fieldTitle || DateInput._title
  }

   set title(val) {
    this.fieldTitle = val
		this.temTitle = val
  }
}

DateInput._title = '日期'
DateInput.type = FORM_ITEM__DATE
DateInput.use = true
DateInput.icon = 'iconfont icon-zuoyeshijianduan'

DateInput.prototype.type = DateInput.type
DateInput.prototype.dataType = DATA_TYPE__LONG
DateInput.prototype.dataTypeList = [
  {
    label: '精确到天',
    value: DATE_TYPE__DAY
  },
  {
    label: '精确到秒',
    value: DATE_TYPE__SECTION
  }
]
DateInput.prototype.defaultValueList = [
  {
    label: '不设置',
    value: {
      defaultType: ''
    }
  },
  {
    label: "自定义",
    value: defaultValueInit(DEFAULT_VALUE__CUSTOM)
  },
  {
    label: "表单提交时间",
    value: defaultValueInit(DEFAULT_VALUE__CREATE_TIME)
  },
  {
    label: '公式',
    value: defaultValueInit(DEFAULT_VALUE__FORMULA)
  },
  {
    label: '关联数据',
    value: defaultValueInit(DEFAULT_VALUE__RELATE_DATA)
  }
]
DateInput.prototype.filterOpts = [
  {
    name: '等于',
    method: 'eq'
  },
  {
    name: '不等于',
    method: 'ne'
  },
  {
    name: '大于等于',
    method: 'gte'
  },
  {
    name: '小于等于',
    method: 'lte'
  },
  {
    name: '选择范围',
    method: 'range'
  },
  {
    name: '为空',
    method: 'empty'
  },
  {
    name: '不为空',
    method: 'not_empty'
  },
]
DateInput.prototype.percentList = [50, 75, 100]
DateInput.prototype.getValue = function () {
  return this.value
}
DateInput.prototype.setValue = function (val) {
  if (this.parent && this.parent.type === FORM_ITEM__TABLE) {
    return
  }

  if (val) {
    this.value = Number(val)
  } else {
    this.value = null
    if (this.defaultValue) {
      if (this.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
        this.modified = true
        this.value = this.defaultValue.customValue
      } else if (this.root.status === FORM_STATUS__FILL
        && this.defaultValue.defaultType === DEFAULT_VALUE__CREATE_TIME) {
        this.modified = true
        this.value = Date.now()
      }
    }
  }
}
DateInput.prototype.getConf = function () {
  const base = this.getBase()
  return {
    ...base,
    dateType: this.dateType,
    checkCondition: this.checkCondition,
    defaultValue: this.defaultValue,
    formatStr: this.formatStr
  }
}
DateInput.prototype.setConf = function (opts) {
  this.setBase(opts)
  if (opts.checkCondition) {
    this.checkCondition = opts.checkCondition
  }
  if (opts.defaultValue) {
    this.defaultValue = opts.defaultValue
    if (opts.defaultValue.defaultType === DEFAULT_VALUE__CUSTOM) {
      this.value = this.defaultValue.customValue
    } else if (this.root.status === FORM_STATUS__FILL
      && opts.defaultValue.defaultType === DEFAULT_VALUE__CREATE_TIME) {
      this.value = Date.now()
    }
  }
  this.dateType = opts.dateType || this.dataTypeList[0].value
  this.formatStr = opts.formatStr || 'yyyy-MM-dd HH:mm'
}
DateInput.prototype.valueToString = function (value) {
  if (Object.prototype.toString.call(value) === '[object Null]' ||
    Object.prototype.toString.call(value) === '[object Undefined]') {
    value = value || this.value
  }
  let format = 'yyyy-MM-dd HH:mm:ss'
  if (this.dateType === DATE_TYPE__DAY) {
    format = 'yyyy-MM-dd'
  }
  if (Object.prototype.toString.call(value) === '[object Null]' ||
    Object.prototype.toString.call(value) === '[object Undefined]') {
    return ''
  } else {
    return formatDate(value)(format)
  }
}

export default DateInput
